<template>
  <loading v-if="loading" />

  <div id="wrapper" class="noheader">
    <div class="content appointment">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>預約查詢</p>
          <span></span>
        </div>
        <a class="arr" @click="btnBack"><div class="inner"></div></a>
      </div>
      <div class="appointmentBox addbottom" v-if="!appointments.length">
        <div class="box title">
          <div><span>掛號內容</span></div>
          <div><span>預約序號</span></div>
          <div><span>&nbsp;</span></div>
        </div>
        <div style="margin-top:2rem;text-align:center;">
          <p>
            {{
              message === null
                ? "您目前沒有任何掛號。"
                : "請先申請帳號並完成驗證後方能查詢。"
            }}
          </p>
        </div>
      </div>
      <div class="appointmentBox" v-if="appointments.length">
        <div class="box title">
          <div><span>掛號內容</span></div>
          <div><span>預約序號</span></div>
          <div class="bottom"><span>&nbsp;</span></div>
        </div>
        <div class="box" v-for="(a, idx) in appointments" :key="idx">
          <div>
            <span>{{ a.日期 }}&nbsp;{{ a.診別 }}&nbsp;{{ a.班別 }}診</span>
            <p>{{ a.科別 }}&nbsp;{{ a.醫師名 }}&nbsp;{{ a.title }}</p>
            <div class="patient">{{ a.name }} {{ a.patientNo }}</div>
            <!-- <div
              v-if="suggestedCheckInTime(a)"
              style="margin-top: 6px; font-size: 0.75em;"
            >
              建議報到時間
              <a style="color:#F09E49">{{ suggestedCheckInTime(a) }}</a>
            </div> -->
          </div>
          <div class="number" style="position: relative; bottom: 20px">
            {{ a.掛號序號 }}
          </div>
          <div
            class="bottom"
            style="position: relative; bottom: 25px"
            @click.prevent="btnCancel(a)"
          >
            <p>取消預約</p>
          </div>
        </div>
      </div>
      <p class="appointmentTxt">
        當入看診請留意看診進度，如您初次至木生看診，<br />請準備身分證字號方便建立病歷。
      </p>
    </div>
  </div>

  <modal v-if="modal.display" @close="modal.display = false">
    <template v-slot:header v-if="modal.header">{{ modal.header }}</template>
    <template v-slot:body>{{ modal.body }}</template>
  </modal>

  <confirm v-if="confirm.display" @no="confirm.display = false" @yes="cancel">
    <template v-slot:header v-if="confirm.header">{{
      confirm.header
    }}</template>
    <template v-slot:body>{{ confirm.body }}</template>
  </confirm>

  <debug v-if="debug">{{ member }}</debug>
</template>

<script>
import api from "../api/index";

export default {
  data() {
    return {
      debug: eval(process.env.VUE_APP_DEBUG),
      loading: false,
      modal: {},
      confirm: {},
      appointments: [],
      cancelAppointment: {}, //欲取消的預約資訊
      message: null
    };
  },
  mounted() {
    this.getAppointments();
  },
  computed: {
    member() {
      return this.$store.state.member;
    },
    from() {
      return this.$store.state.from;
    }
  },
  methods: {
    suggestedCheckInTime(apt) {
      if (apt.診別.indexOf("影像") >= 0) return "請洽院所";
      switch (true) {
        // 婦產科
        case apt.科別 === "婦產科" && apt.班別 === "早" && apt.掛號序號 <= 5:
          return "09:30 前 (12:30截止)";
        case apt.科別 === "婦產科" && apt.班別 === "早" && apt.掛號序號 <= 20:
          return "10:30 前 (12:30截止)";
        case apt.科別 === "婦產科" && apt.班別 === "早":
          return "12:30 截止前";
        case apt.科別 === "婦產科" && apt.班別 === "午" && apt.掛號序號 <= 5:
          return "14:30 前 (17:00截止)";
        case apt.科別 === "婦產科" && apt.班別 === "午" && apt.掛號序號 <= 20:
          return "15:30 前 (17:00截止)";
        case apt.科別 === "婦產科" && apt.班別 === "午":
          return "17:00 截止前";
        case apt.科別 === "婦產科" && apt.班別 === "晚" && apt.掛號序號 <= 5:
          return "19:00 前 (21:00截止)";
        case apt.科別 === "婦產科" && apt.班別 === "晚" && apt.掛號序號 <= 20:
          return "20:00 前 (21:00截止)";
        case apt.科別 === "婦產科" && apt.班別 === "晚":
          return "21:00 截止前";
        // 小兒科
        case apt.科別 === "小兒科" && apt.班別 === "早" && apt.掛號序號 <= 39:
          return "09:00 ~ 10:30 (11:30截止)";
        case apt.科別 === "小兒科" && apt.班別 === "早":
          return "11:30 截止前";
        case apt.科別 === "小兒科" && apt.班別 === "午" && apt.掛號序號 <= 39:
          return "14:00 ~ 15:30 (16:00截止)";
        case apt.科別 === "小兒科" && apt.班別 === "午":
          return "16:00 截止前";
        case apt.科別 === "小兒科" && apt.班別 === "晚" && apt.掛號序號 <= 39:
          return "暫停看診";
        case apt.科別 === "小兒科" && apt.班別 === "晚":
          return "暫停看診";
        default:
          return "";
      }
    },
    getAppointments() {
      this.loading = true;
      api.appointment
        .query({
          jwt: this.member.jwt
        })
        .then(data => {
          console.log(data);
          this.loading = false;
          this.appointments = data.appointments;
        })
        .catch(error => {
          this.loading = false;
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    },
    btnCancel(appointment) {
      this.cancelAppointment = appointment;
      this.confirm = {
        display: true,
        body: `確認取消 ${appointment.日期} ${appointment.科別} ${appointment.醫師名} ${appointment.title}的預約嗎?`
      };
    },
    cancel() {
      this.confirm.display = false;
      this.loading = true;
      api.appointment
        .cancel({
          jwt: this.member.jwt,
          appointment: this.cancelAppointment
        })
        .then(data => {
          console.log(data);
          this.getAppointments(); //重新讀取
        })
        .catch(error => {
          this.loading = false;
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    },
    btnBack() {
      let url =
        this.from === "/MemberShip" ? "/MemberShip" : "/guest/line/HomePage";
      this.$router.replace(url);
    }
  }
};
</script>

<style scoped>
.patient {
  padding-top: 0.3rem;
  font-size: 0.8rem;
  color: grey;
}
</style>
